import { Component, OnInit } from '@angular/core';
import * as Chartist from 'chartist';
import { DataService } from 'app/data.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  data: any

  propertiesUrl = environment.url + '/properties'

  statesCount: any

  districtCount: any

  locationCount: any

  userData: any

  earnings: any

  constructor( private adminService: DataService ) { }

  ngOnInit() {
    this.getStats()
    this.getUserStats()
    this.getEarningStats()
  }

  getEarningStats(){
    this.adminService.getEarningInfo().subscribe( data => {
      console.log(data)
      if(data.status){
        this.earnings = data.values
      }
    })
  }

  getUserStats(){
    this.adminService.getUserStats().subscribe(data => {
      console.log(data)
      if(data.status){
        this.userData = data.values
      }
    })
  }

  getStats(){
    this.adminService.getDashboardInfo().subscribe(data => {
      data['totalAds'] = data['totalPendingAds'] + data['totalExpiredAds'] + data['totalRequestedAds'] + data['totalVerifiedAds']
      this.data = data
    })
    this.adminService.states().subscribe(data => {
      this.statesCount = data.provinces.length
    })
    this.adminService.districts().subscribe(data => {
      this.districtCount = data.districts.length
    })
    this.adminService.municipalities().subscribe(data => {
      this.locationCount = data.municipalities.length
    })
  }

}
